var __templateData = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var stack1, helper, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", buffer = "<h4><b>"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "test_accuracy", {"name":"i18n","hash":{},"data":data})))
    + "</b></h4>\n<div class=\"test-accuracy-summary\">\n    <span>"
    + escapeExpression(((helper = (helper = helpers.indexTest || (depth0 != null ? depth0.indexTest : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"indexTest","hash":{},"data":data}) : helper)))
    + "</span>\n    <span>"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "sensitivity", {"name":"i18n","hash":{},"data":data})))
    + ": "
    + escapeExpression(((helpers.sensitivity || (depth0 && depth0.sensitivity) || helperMissing).call(depth0, depth0, false, {"name":"sensitivity","hash":{},"data":data})))
    + "</span>\n    <span>"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "specificity", {"name":"i18n","hash":{},"data":data})))
    + ": "
    + escapeExpression(((helpers.specificity || (depth0 && depth0.specificity) || helperMissing).call(depth0, depth0, false, {"name":"specificity","hash":{},"data":data})))
    + "</span>\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.comparatorTestPresent : depth0), {"name":"if","hash":{},"fn":this.program(2, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>\n";
},"2":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "    <br/>\n    <span>"
    + escapeExpression(((helper = (helper = helpers.comparatorTest || (depth0 != null ? depth0.comparatorTest : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"comparatorTest","hash":{},"data":data}) : helper)))
    + "</span>\n    <span>"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "sensitivity", {"name":"i18n","hash":{},"data":data})))
    + ": "
    + escapeExpression(((helpers.sensitivity || (depth0 && depth0.sensitivity) || helperMissing).call(depth0, depth0, true, {"name":"sensitivity","hash":{},"data":data})))
    + "</span>\n    <span>"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "specificity", {"name":"i18n","hash":{},"data":data})))
    + ": "
    + escapeExpression(((helpers.specificity || (depth0 && depth0.specificity) || helperMissing).call(depth0, depth0, true, {"name":"specificity","hash":{},"data":data})))
    + "</span>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, buffer = "";
  stack1 = ((helpers.i18nNamespace || (depth0 && depth0.i18nNamespace) || helperMissing).call(depth0, "es:outcome.diagnostic", {"name":"i18nNamespace","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data}));
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"useData":true});
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}